import { Eye } from "lucide-react";
import { useIsTeamViewer } from "~/hooks/useTeamAccess";

export default function ViewerBanner() {
  const isViewer = useIsTeamViewer();

  if (!isViewer) {
    return null;
  }

  return (
    <div className="shrink-0 border-b bg-muted/60 px-4 py-2">
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <Eye className="size-4 shrink-0" />
        <p className="min-w-0 flex-1">
          You have view-only access to this team. Ask a team owner or admin if
          you need to change something.
        </p>
      </div>
    </div>
  );
}
